import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ResultTable from "./ResultTable";

import API from '../../tools/API';

import styles from "./SingleResult.module.scss";
import { SingleResultEntry, SinglePoll } from '../../tools/interfaces';

const SingleResult = () => {
    const { id } = useParams();
    const [poll, setPoll] = useState<SingleResultEntry[]>();
    const [pollInfo, setPollInfo] = useState<SinglePoll>();

    const getDate = (date: string | undefined) => {
        if (!date) return null
        const selectetDate = new Date(date);
        const day = selectetDate.getDate() <= 9 ? `0${selectetDate.getDate()}` : selectetDate.getDate();
        const month = selectetDate.getMonth() + 1 <= 9 ? `0${selectetDate.getMonth() + 1}` : selectetDate.getMonth();
        const year = selectetDate.getFullYear();
        return `${day}.${month}.${year}`
    }


    useEffect(() => {
        API.getSingleResult(id as string).then((res) => {
            setPoll(res?.data.data);
        })
        API.getSinglePoll(id as string).then((res) => {
            setPollInfo(res?.data.data);
        })
    }, []);



    return (
        <section className={styles.main}>
            <div className={styles.topRow}>


            </div>
            <div className={styles.pollData}>
                <h2 className={styles.pollName}>{pollInfo?.name} ({getDate(pollInfo?.dateFrom)} - {getDate(pollInfo?.dateTo)})</h2>

                <div className={styles.optionsWrapper}>


                    <ol className={styles.optionList}>
                        {poll && (
                            poll.map((el: SingleResultEntry, index: number) => {
                                return (
                                    <li key={el.id + 'key'}>
                                        <ResultTable
                                            title={el.title}
                                            artist={el.artist}
                                            image={el.image}
                                            file={el.file}
                                            content={el.content}
                                            id={el.id}
                                            pollId={id}
                                            percentOfVotes={el.score}
                                            numberOfVotes={el.noOfVotes}
                                            trend={el.trend}
                                            index={index}
                                        />
                                    </li>
                                )
                            }
                            )
                        )}
                    </ol>

                </div>
            </div>

        </section >
    )
}

export default SingleResult;